import { NgModule } from "@angular/core";
import { OverviewComponent } from "./overview/overview";
import { CommonModule } from "@angular/common";
import { AfHeaderComponent } from "./af-header/af-header";
import { LicensePlateComponent } from "./license-plate/license-plate";
import { PipesModule } from "../pipes/pipes.module";
import { IonicModule } from "ionic-angular";
import { MyApp } from "../app/app.component";
import { StatusComponent } from "./status/status";

@NgModule({
  declarations: [
    OverviewComponent,
    AfHeaderComponent,
    LicensePlateComponent,
    StatusComponent,
  ],
  imports: [CommonModule, PipesModule, IonicModule.forRoot(MyApp)],
  exports: [
    OverviewComponent,
    AfHeaderComponent,
    LicensePlateComponent,
    StatusComponent,
  ],
})
export class ComponentsModule {}



// WEBPACK FOOTER //
// ./src/components/components.module.ts